import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";

export default function EmailResults({ toolKey, results }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) { toast.error("Enter a valid email"); return; }
    setLoading(true);
    try {
      await api.post("/public/lead", { email, source: `tool:${toolKey}`, meta: { tool: toolKey, results } });
      setDone(true);
    } catch { toast.error("Could not save — try again"); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div className="border border-emerald-500/30 bg-emerald-500/5 rounded-sm p-5 flex items-start gap-3 no-print" data-testid="email-results-success">
      <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
      <div className="text-sm">Got it — your results are on their way to <b>{email}</b>.</div>
    </div>
  );

  return (
    <form onSubmit={submit} className="border border-border bg-card rounded-sm p-5 flex flex-col md:flex-row md:items-center gap-3 no-print" data-testid="email-results-form">
      <div className="flex items-center gap-3 md:flex-1">
        <Mail className="w-5 h-5 text-primary shrink-0" />
        <div>
          <div className="font-semibold text-sm">Email me my results</div>
          <div className="text-xs text-muted-foreground">Optional. A copy for your records — no spam.</div>
        </div>
      </div>
      <input
        type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@plant.com"
        className="border border-input bg-background rounded-sm px-3 h-11 text-sm outline-none focus:border-primary md:w-64"
        data-testid="email-results-input"
      />
      <Button type="submit" disabled={loading} className="rounded-sm h-11 bg-accent hover:bg-accent/90 text-white" data-testid="email-results-submit">
        {loading ? "Saving…" : "Send results"}
      </Button>
    </form>
  );
}
